"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DRAFT_STATE_ITERABLE = exports.PUBLISHED_STATE_ITERABLE = exports.FrequencyType = exports.FrequencyPeriod = exports.References = exports.DomainEntity = exports.DataTapeField = exports.Config = void 0;
exports.Config = __importStar(require("./Config"));
var DataTapeField_1 = require("./DataTapeField");
Object.defineProperty(exports, "DataTapeField", { enumerable: true, get: function () { return DataTapeField_1.DataTapeField; } });
exports.DomainEntity = __importStar(require("./DomainEntity"));
exports.References = __importStar(require("./References"));
var Utils_1 = require("../Utils");
Object.defineProperty(exports, "FrequencyPeriod", { enumerable: true, get: function () { return Utils_1.FrequencyPeriod; } });
Object.defineProperty(exports, "FrequencyType", { enumerable: true, get: function () { return Utils_1.FrequencyType; } });
exports.PUBLISHED_STATE_ITERABLE = [
    'latestPublished',
    'published',
];
exports.DRAFT_STATE_ITERABLE = [
    'latestDraft',
]; // TODO: @markhaghani add 'draft' when we add drafts
// | 'submitted' // Status can change to 'latestPublished', 'rejected', or 'canceled'.
// | 'rejected' // Immutable CA obj & status.
// | 'canceled'; // Immutable CA obj & status.
//# sourceMappingURL=index.js.map